import throttle from "lodash/throttle";
import { useEffect, useRef } from "react";

export const useIntersectionObserver = (setPassedSection: (isPassed: boolean) => void) => {
    const componentRef = useRef(null);

    const handleScroll = () => {
        const observer = new IntersectionObserver(
            (entries) => {
                setPassedSection(!entries[0].isIntersecting);
            },
            { threshold: 0.5 },
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }
    };

    useEffect(() => {
        setPassedSection(false);
        const throttledHandleScroll = throttle(handleScroll, 100);

        window.addEventListener("scroll", throttledHandleScroll);

        return () => {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, []);

    return { componentRef };
};
